// extracted by mini-css-extract-plugin
export default {"scrollUpButton":"SideNav_scrollUpButton__NuvRz","scrollDownButton":"SideNav_scrollDownButton__Fa5fH","navBarSmoothScroll":"SideNav_navBarSmoothScroll__PLyaG"};